export const isCS = (variant) => {
    return variant.codePackage && variant.codePackage.endsWith("CS")
}